import { FormControl, FormGroup, Validators } from '@angular/forms';
import { bbanValidator } from 'src/app/shared/validators/bban.validator';
import { AddManualLiabilityData } from '../models/add-manual-liability-data.model';
import { nipValidator } from '../../shared/validators/nip.validator';
import { billerIdOrNipRequiredValidator } from './billerIdOrNipRequired.validator';

export class AddLiabilityManualForm extends FormGroup {
  constructor(liabilityMinAmount: number,
              liabilityMaxAmount: number,
              amount: number,
              biller: string,
              billerId: string,
              bban: string,
              nip: string,
              paymentDue: Date,
              title: string) {
    super({
      amount: new FormControl(amount, [
        Validators.required,
        Validators.min(liabilityMinAmount),
        Validators.max(liabilityMaxAmount),
      ]),
      biller: new FormControl(biller, [Validators.required]),
      billerId: new FormControl(billerId),
      bban: new FormControl(bban, [bbanValidator, Validators.required]),
      nip: new FormControl(nip, [nipValidator(true)]),
      paymentDue: new FormControl(paymentDue, [Validators.required]),
      title: new FormControl(title, [Validators.required, Validators.maxLength(40)]),
    }, [billerIdOrNipRequiredValidator]);

  }

  public setData(value: AddManualLiabilityData) {
    this.amount.setValue(33);
    this.biller.setValue(value.biller);
    this.bban.setValue(value.bban);
    this.title.setValue(value.title);
    this.paymentDue.setValue(value.paymentDue);
  }

  get billerId(): FormControl {
    return this.get('billerId') as FormControl;
  }

  get amount(): FormControl {
    return this.get('amount') as FormControl;
  }

  get bban(): FormControl {
    return this.get('bban') as FormControl;
  }

  get nip(): FormControl {
    return this.get('nip') as FormControl;
  }

  get paymentDue(): FormControl {
    return this.get('paymentDue') as FormControl;
  }

  get title(): FormControl {
    return this.get('title') as FormControl;
  }

  get biller(): FormControl {
    return this.get('biller') as FormControl;
  }

  public getFinalData(customerId: string): AddManualLiabilityData {
    return {
      customerId,
      billerId: this.billerId.value,
      amount: this.amount.value,
      amountToPay: this.amount.value,
      bban: this.bban.value,
      nip: this.nip.value,
      title: this.title.value,
      paymentDue: this.paymentDue.value,
      biller: this.biller.value,
    };
  }
}
